import { render } from "./FormAddPatient.vue?vue&type=template&id=244fb04c&scoped=true"
import script from "./FormAddPatient.vue?vue&type=script&lang=js"
export * from "./FormAddPatient.vue?vue&type=script&lang=js"

import "./FormAddPatient.vue?vue&type=style&index=0&id=244fb04c&scoped=true&lang=css"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244fb04c"]])

export default __exports__